const BREAKPOINTS = {
  small: 480,
  med: 768,
  large: 1026,
  xLarge: 1200,
};

export default BREAKPOINTS;
